import React, { useState } from "react";
import Styles from "./ChildTransaction.module.css";
import { IconButton, Modal, Tooltip } from "@mui/material";
import { Close, Info } from "@mui/icons-material";
import { useSelector } from "react-redux";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Payouts from "../../Schedule/Payouts/Payouts";

const ChildTransaction = ({ open, handleClose, data, parentData }) => {
  console.debug("parentData", parentData, data);
  const [repId, setRepId] = useState("");
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  ).toLowerCase();

  const [openPayout, setOpenPayouts] = useState(false);
  return (
    <>
      {openPayout && (
        <Payouts
          open={openPayout}
          handleClose={() => setOpenPayouts(false)}
          viewOnly={true}
          id={parentData?.bilateralContractId}
          repId={repId}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.childTransactionModal}`}>
          <div className="modalHeading">
            View Daily Contract
            <Close
              onClick={handleClose}
              style={{ cursor: "pointer" }}
              alterbutton="false"
            />
          </div>
          <div className={Styles.parentListingContainer}>
            <div className={Styles.upperParentCont}>
              <div>Contract Id</div>
              <div>{parentData?.bilateralContractUniqueId || "-"}</div>
            </div>
            <div className={Styles.upperParentCont}>
              <div>Self Listing Id</div>
              <div>
                {
                  (role === "consumer"
                    ? parentData?.name?.split("-")?.[0]?.includes("C")
                      ? parentData?.name?.split("-")?.[0]
                      : parentData?.name?.split("-")?.[1]
                    : parentData?.name?.split("-")?.[1]?.includes("G")
                    ? parentData?.name?.split("-")?.[1]
                    : parentData?.name?.split("-")?.[0]
                  )?.split("_")?.[0]
                }
              </div>
            </div>
            <div className={Styles.upperParentCont}>
              <div>Counterparty</div>
              <div>
                {role === "consumer"
                  ? `${parentData?.generatorName}`
                  : role === "generator"
                  ? `${parentData?.consumerName}`
                  : `${parentData?.consumerName}-${parentData?.generatorName}`}
              </div>
            </div>

            <div className={Styles.upperParentCont}>
              <div>Total Contract Value (₹)</div>
              <div>{parentData?.scheduleAmount?.toFixed(2)}</div>
            </div>
            <div className={Styles.upperParentCont}>
              <div>Total Blocked Amount (₹)</div>
              <div>{parentData?.amountBlocked?.toFixed(2)}</div>
            </div>
            <div className={Styles.upperParentCont_status}>
              <div>Schedule</div>
              <div
                className={`${
                  parentData?.status === "COMPLETED"
                    ? "accepted"
                    : parentData?.status === "PENDING"
                    ? "pending"
                    : "rejected"
                }`}
              >
                {parentData?.status === "COMPLETED"
                  ? "Completed"
                  : parentData?.status === "PENDING"
                  ? "Ongoing"
                  : "Rejected"}
              </div>
            </div>
          </div>
          <div className={Styles.tableContainer}>
            <div className="tableHeading display_flex_row">
              <div style={{ width: "10%" }}>Date</div>
              <div style={{ width: "20%" }}>Time Range</div>
              <div style={{ width: "15%" }}>Sch Qty (MWH)</div>
              <div style={{ width: "15%" }}>
                <div>Est. Amount(₹)</div>
                <Tooltip
                  title={"Estimated amount as per schedule quantum."}
                  arrow
                >
                  <Info
                    style={{
                      fontSize: 16,
                      color: "#666",
                      marginLeft: "4px",
                    }}
                  />
                </Tooltip>
              </div>
              <div style={{ width: "16%" }}>Amount Blocked(₹)</div>
              <div style={{ width: "5%" }}>Payouts</div>
            </div>
            <div className={`scroll_bar_y ${Styles.childTransactionTable}`}>
              {data?.map((ele, index) => (
                <div className="tableDetails display_flex_row">
                  <div style={{ width: "10%" }}>{ele?.date}</div>
                  <div style={{ width: "20%" }}>
                    {ele?.scheduleStartTime?.split(":")?.[0]}:
                    {ele?.scheduleStartTime?.split(":")?.[1]} to{" "}
                    {ele?.scheduleEndTime === "23:59:59"
                      ? "24:00"
                      : `${ele?.scheduleEndTime?.split(":")?.[0]}:${
                          ele?.scheduleEndTime?.split(":")?.[1]
                        }`}
                  </div>
                  <div style={{ width: "15%" }}>{ele?.volume}</div>
                  <div style={{ width: "15%" }}>{ele?.amount?.toFixed(2)}</div>
                  <div style={{ width: "16%" }}>
                    {ele?.amountBlocked?.toFixed(2)}
                  </div>
                  <div style={{ width: "5%" }}>
                    <RemoveRedEyeIcon
                      style={{ fontSize: "14px", color: "#f1935c" }}
                      onClick={() => {
                        setOpenPayouts(true);
                        setRepId(ele?.repScheduleId);
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ChildTransaction;
